<template><div></div></template>

<script>
import { routeManager } from "@/services/utilities/route-manager";
import { platformManager } from "@/services/platform/platform-manager";

export default {
  name: "RedirectedRoute",
  data() {
    return {
      domainToRedirect: [
        "studea.ensuplr.fr",
        "www.studea-parisnanterre.fr",
        "www.lea-cfa-leem.fr",
        "www.lea-lecole-cci.fr",
      ],
      platform: {},
    };
  },
  mounted() {
    const route = new URL(this.$route.query.from);
    if (route.pathname.includes("sl")) {
      this.getMagicLinkRedirectedRoute(route);
    } else {
      this.getRegistrationRedirectedRoute(route);
    }
  },
  methods: {
    getRegistrationRedirectedRoute(route) {
      if (this.domainToRedirect.includes(route.hostname)) {
        platformManager.loadPlatform().then((res) => {
          this.platform = res;
          if (this.platform && this.platform.hostnameV2) {
            window.location.href = this.platform.hostnameV2 + route.pathname;
          } else {
            this.$router.push({ name: "Error" });
          }
        });
      } else {
        this.$router.push({ name: "Error" });
      }
    },

    getMagicLinkRedirectedRoute(route) {
      const cryptedId = route.pathname.substring(4);
      routeManager.getMagicLinkFromV2(cryptedId).then((res) => {
        if (res && res.redirectLink) {
          window.location.href = res.redirectLink;
        } else {
          this.$router.push({ name: "Error" });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
